import React from 'react';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { useHistory } from 'react-router-dom';

import useVideo from '../../store/video/useVideo';
import useAuth from '../../store/auth/useAuth';
import useUserPreferencesContext from '../../store/userPreferences/useUserPreferencesContext';
import List from './List';
import { DivContainer, DivVideo, DivVideoDetails, TypographyDescription } from './Video.styled';

const Home = () => {
  const { video, videos } = useVideo();
  const { isLoggedIn } = useAuth();
  const { favoriteVideos, isFavoriteVideo, addFavoriteVideo, removeFavoriteVideo } = useUserPreferencesContext();
  const { replace, location } = useHistory();

  const videosList = location.pathname.includes('favorites') ? favoriteVideos : videos;
  const getVideoPath = ({ id }) => {
    if (location.pathname.includes('favorites')) {
      return `/favorites/${id}`;
    }
    return `/${id}`;
  };

  if (!video) {
    replace('/');
    return null;
  }

  const { id, title, description } = video;

  return (
    <DivContainer>
      <DivVideo>
        <iframe title="video" width="100%" height="500px" src={`https://www.youtube.com/embed/${id}`} />
        <DivVideoDetails>
          <Typography gutterBottom variant="h5" component="h2">
            {title}
          </Typography>
          {isLoggedIn
            && (isFavoriteVideo(video) ? (
              <Button onClick={() => removeFavoriteVideo(video)}>Remover de favoritos</Button>
            ) : (
              <Button onClick={() => addFavoriteVideo(video)}>Agregar a favoritos</Button>
            ))}
        </DivVideoDetails>
        <TypographyDescription variant="body2" color="textSecondary" component="p">
          {description}
        </TypographyDescription>
      </DivVideo>
      <List videos={videosList} getVideoPath={getVideoPath} />
    </DivContainer>
  );
};

Home.propTypes = {};

export default Home;
